module.exports = __webpack_public_path__ + "static/icon_bausteine-1cf81ae3ab40547c974d1f56bae4fab2.png";